import React, { Fragment } from "react";

const VideoRender = (props) => {
  const {
    setVideoDetails = () => {},
    videoThumbnail = "",
    videoUrl = "",
  } = props;
  return (
    <Fragment>
      <div className="col-md-3">
        <div
          style={{
            backgroundImage: `url(${videoThumbnail})`,
            width: 120,
            height: 120,
            cursor: "pointer",
            position: "relative",
            backgroundSize: "cover",
            backgroundPosition: "50%",
            backgroundRepeat: "no-repeat",
            border: "1px solid black",
          }}
        ></div>
        <i
          className="fa fa-play theme-fa-icon"
          style={{
            position: "absolute",
            left: " 70px",
            top: "50px",
            cursor: "pointer",
            color: "#fff",
          }}
          data-toggle="modal"
          data-original-title="test"
          data-target="#exampleModal"
          onClick={() => {
            let video = videoUrl.split("videos");
            let objItem = {
              base_url: video[0] + "videos",
              document: video[1],
              video_thumbnail: videoThumbnail,
            };
            setVideoDetails({
              ...objItem,
            });
          }}
        ></i>
      </div>
    </Fragment>
  );
};

export default VideoRender;
